
import type { CoupleNameOrder } from "../../../../../../types/wedding";
import { getCoupleDisplayName } from "../../../../../../utils/couple.names";

const getWeddingText = (
  brideFirstName: string,
  groomFirstName: string,
  coupleNameOrder?: CoupleNameOrder,
) =>
  getCoupleDisplayName({
    brideFirstName,
    groomFirstName,
    coupleNameOrder,
  }) || "...";

export default getWeddingText;
